export const C_DECIMAL_PLACES = 2;
export const C_POOL_TOKEN_DECIMALS = 6;
